var map = {
	"./apps/ai/featureSelection/featureSelection.duck.js": 112,
	"./apps/ai/manager/userPrompt/userPrompt.duck.js": 110,
	"./apps/ai/preferences/preferences.duck.js": 70,
	"./apps/combinedContextLoader/combinedContextLoader.duck.js": 92,
	"./apps/comments/commentsDisplay/commentsDisplay.duck.js": 492,
	"./apps/comments/listOfComments.duck.js": 459,
	"./apps/comments/singleComment/singleComment.duck.js": 460,
	"./apps/dashboard/actionlist/actionlist.duck.js": 163,
	"./apps/dashboard/dashboard.duck.js": 493,
	"./apps/dashboard/dashboardWidget/dashboardWidget.duck.js": 494,
	"./apps/dashboard/listofdocument/listofdocument.duck.js": 495,
	"./apps/dashboard/v2dashboardwidget/v2dashboardwidget.duck.js": 496,
	"./apps/projectManagement/addProjectModal/addProjectModal.duck.js": 164,
	"./apps/projectManagement/projectConfig/projectConfig.duck.js": 93,
	"./apps/tour/tour.duck.js": 497,
	"./apps/workflow/headingWorkflow/headingWorkflow.duck.js": 103,
	"./apps/workflow/schemaBasedEditor/components/actionButtonArrayFieldTemplate/actionButtonArrayFieldTemplate.duck.js": 498,
	"./apps/workflow/schemaBasedEditor/components/arrayFieldTemplate/arrayFieldTemplate.duck.js": 499,
	"./apps/workflow/schemaBasedEditor/components/assigneeDropdown/assigneeDropdown.duck.js": 500,
	"./apps/workflow/schemaBasedEditor/components/checkboxWidget/checkboxWidget.duck.js": 501,
	"./apps/workflow/schemaBasedEditor/components/inputWidget/inputWidget.duck.js": 502,
	"./apps/workflow/schemaBasedEditor/components/primaryActionFieldTemplate/primaryActionFieldTemplate.duck.js": 503,
	"./apps/workflow/schemaBasedEditor/components/sectionTitle/sectionTitle.duck.js": 504,
	"./apps/workflow/schemaBasedEditor/components/selectWidget/selectWidget.duck.js": 505,
	"./apps/workflow/schemaBasedEditor/components/stageDropdown/stageDropdown.duck.js": 506,
	"./apps/workflow/schemaBasedEditor/components/topLevelArrayFieldTemplate/topLevelArrayFieldTemplate.duck.js": 507,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.duck.js": 95,
	"./apps/workflow/workflowEditor/document/documentWorkflowEditor.duck.js": 94,
	"./apps/workflow/workflowEditor/heading/headingWorkflowEditor.duck.js": 74,
	"./apps/workflow/workflowWidget/components/adminWorkflowStatus/adminWorkflowStatus.duck.js": 508,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.duck.js": 161,
	"./apps/workflow/workflowWidget/components/approveModal/approveModal.duck.js": 509,
	"./apps/workflow/workflowWidget/components/assignableUsersSelect/assignableUsersSelect.duck.js": 510,
	"./apps/workflow/workflowWidget/components/assignedDocuments/assignedDocuments.duck.js": 511,
	"./apps/workflow/workflowWidget/components/authorAssignedBy/authorAssignedBy.duck.js": 512,
	"./apps/workflow/workflowWidget/components/authorCompleteBy/authorCompleteBy.duck.js": 513,
	"./apps/workflow/workflowWidget/components/executiveApproval/executiveApproval.duck.js": 514,
	"./apps/workflow/workflowWidget/components/executiveApproveBy/executiveApproveBy.duck.js": 515,
	"./apps/workflow/workflowWidget/components/executiveLastApproved/executiveLastApproved.duck.js": 516,
	"./apps/workflow/workflowWidget/components/nextDocumentButton/nextDocumentButton.duck.js": 517,
	"./apps/workflow/workflowWidget/components/progressButton/progressButton.duck.js": 518,
	"./apps/workflow/workflowWidget/components/widgetHeader/widgetHeader.duck.js": 519,
	"./apps/workflow/workflowWidget/components/workflowMessage/workflowMessage.duck.js": 520,
	"./apps/workflow/workflowWidget/components/workflowSettingsModal/workflowSettingsModal.duck.js": 521,
	"./apps/workflow/workflowWidget/components/workflowSettingsModalRow/workflowSettingsModalRow.duck.js": 522,
	"./apps/workflow/workflowWidget/components/workflowStatus/workflowStatus.duck.js": 523,
	"./apps/workflow/workflowWidget/workflowWidget.duck.js": 18,
	"./contexts/account/account.duck.js": 149,
	"./contexts/document/document.duck.js": 66,
	"./contexts/heading/heading.duck.js": 63,
	"./contexts/instance/instance.duck.js": 150,
	"./contexts/organisation/organisation.duck.js": 151,
	"./contexts/project/dataTypes/groups/groups.duck.js": 40,
	"./contexts/project/dataTypes/users/users.duck.js": 39,
	"./contexts/project/project.duck.js": 53,
	"./contexts/workflowinstance/workflowinstance.duck.js": 152,
	"./globals/darkTheme.duck.js": 524,
	"./globals/dataTypes/auth/auth.duck.js": 31,
	"./globals/dataTypes/comments/comments.duck.js": 36,
	"./globals/dataTypes/login/login.duck.js": 62,
	"./globals/dataTypes/maintenance/data/data.duck.js": 54,
	"./globals/dataTypes/notificationSettings/notificationSettings.duck.js": 84,
	"./globals/dataTypes/notifications/notifications.duck.js": 78,
	"./globals/dataTypes/performanceLogs/performanceLogs.duck.js": 131,
	"./globals/dataTypes/projects/projects.duck.js": 144,
	"./globals/dataTypes/sysconfig/sysconfig.duck.js": 108,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.duck.js": 55,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.duck.js": 67,
	"./globals/global.duck.js": 120,
	"./parts/modalBehaviour/modalBehaviour.duck.js": 450,
	"./parts/showMoreBehaviour/showMoreBehaviour.duck.js": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;